import { format } from 'date-fns';

// Turn an object of form {key: value, key: value} into a URL
export const objToURLParams = keyValuePairs => {
    return '?' + Object.keys(keyValuePairs).map(key => key + '=' + encodeURIComponent(keyValuePairs[key])).join('&');
};

// This would not work with all URLS, but is sufficient for any that are
// valid for this form. Should security check as well?
export const getParamsFromURL = () => {
    let queryString = window.location.search;
    // console.log(queryString);
    if (!queryString) {
        return {};
    }
    queryString = queryString.substr(1);
    const params = queryString.split('&').reduce((obj, pairString) => {
        const keyValue = pairString.split('=');
        if (keyValue.length !== 2) {
            return obj;
        }
        obj[keyValue[0]] = decodeURIComponent(keyValue[1]).replace('+', ' ');
        return obj;
    }, {});
    return params;
};

export const getInitialFormState = () => {
    const today = new Date();
    const query = getParamsFromURL();
    // const response = getRequiresReservation();
    // console.log(query);
    // console.log(window.otpConfig)

    let results =  {
        form: {
            fields: {
                fromPlace: {
                    value: query.fromPlace ? query.fromPlace : '',
                },
                toPlace: {
                    value: query.toPlace ? query.toPlace : '',
                },
                time: {
                    value: query.time ? query.time : format(today, 'h:mm A')
                },
                date: {
                    value: query.date ? query.date : format(today, 'MM/DD/YYYY')
                },
                arriveBy: {
                    value: query.arriveBy ? query.arriveBy : 'false'
                },
                maxWalkDistance: {
                    value: query.walkPreference ? getMaxWalkDistance(query.walkPreference) : '1600'
                },
                useMap: {
                    value: getMapDefault(query.useMap)
                },
                flexUseReservationServices: {
                    value: getCheckmarkValue(query.flexUseReservationServices)
                },
                flexUseEligibilityServices: {
                    value: getCheckmarkValue(query.flexUseEligibilityServices)
                },
                flexCallAndRideReluctance: {
                    value: query.flexCallAndRideReluctance ? query.flexCallAndRideReluctance : '3.0'
                },
                walkReluctance: {
                    value: query.walkPreference ? getWalkReluctance(query.walkPreference) : '3.0'
                },
                walkPreference: {
                    value: query.walkPreference ? query.walkPreference : 'default'
                }
            }
        }
    };

    if (window.otpConfig.flex2) {
        // console.log('flex2 config ',window.otpConfig.flex2);
        // console.log('results ',results);
        
        results.form.fields.mode = {
            value: query.mode ? query.mode : 'FLEX_ACCESS,FLEX_EGRESS,FLEX_DIRECT,TRANSIT,WALK'
        },
        results.form.fields.optimize = {
            value: query.optimize ? query.optimize : 'TRANSFERS'
        };       
        // results.response.requiresReservation = {
        //     value: getRequiresReservation(query.flexUseReservationServices)
        // };
        
    } else {
        results.form.fields.flexUseEligibilityServices = {
            value: getCheckmarkValue(query.flexUseEligibilityServices)
        };
        results.form.fields.flexUseReservationServices = {
            value: getRequiresReservation(query.flexUseReservationServices)
        };
    } 
    return results;
    
};


const getRequiresReservation = flexUseReservationServices => {
    return (getCheckmarkValue(flexUseReservationServices));
};

export const convertPickupType = checkboxValue => {
    // if (checkboxValue) return '2';
    // if (!checkboxValue) return '0';
    return (checkboxValue);
};

// const getPickupPreference = flexUseReservationServices => {
//     console.log(flexUseReservationServices);
//     // if (getCheckmarkValue(flexUseReservationServices) === 'false') {
//     //     return '0';
//     // } else{
//     //     return '2';
//     // } 
//     return (getCheckmarkValue(flexUseReservationServices));
// };

const getMapDefault = useMap => {
    if (!useMap) {
        if (window.screen.width < 700) {
            return 'false';
        } else {
            return 'true';
        }
    }
    return getCheckmarkValue(useMap);
};

const getWalkReluctance = walkPreference => {
    switch(walkPreference) {
    case 'default':
        // return '1.0';
        return '3.0';
    case 'less':
        return '7.0';
    case 'no':
        return '10.0';
    case 'prefer':
        return '1.0';
    }
};

const getMaxWalkDistance = walkPreference => {
    switch(walkPreference) {
    case 'default':
        return '1600';
    case 'less':
        return '1200';
    case 'no':
        return '50';
    case 'prefer':
        return '4000';
    }
};

export const getCheckmarkValue = queryValue => {
    if (queryValue === 'false') {
        return 'false';
    }
    if (queryValue === 'true' || queryValue === 'on') {
        return 'true';
    }
    return 'false';
};

export const getDeviatedPickupDropoff = leg => {
    if (leg && leg.from && leg.to && leg.from.stopId && leg.to.stopId) {
        let pickupDeviated = leg.from.stopId.includes('area') || leg.from.stopId.includes('radius');
        let dropoffDeviated = leg.to.stopId.includes('area') || leg.to.stopId.includes('radius');
        return pickupDeviated && dropoffDeviated;
    } else {
        return false;
    }

    
}
